
<div class="jobs" [dir]="'Direction' | translate">
    <div class="container"  data-aos="fade-up" data-aos-duration="1000">
        <div class="container" [dir]="'Direction' | translate">
            <span class="section-title">{{ "CookiePolicy.Title" | translate }}</span>
          </div>
        <div class="jobs-inner">
            <div class="cookie-container">
                <div class="cookie-content">
                    <h1>{{ "CookiePolicy.IntroductionTitle" | translate }}</h1>
                    <p>{{ "CookiePolicy.IntroductionContent" | translate }}</p>
                    <h1>{{ "CookiePolicy.UseOfCookiesTitle" | translate }}</h1>
                    <p>{{ "CookiePolicy.UseOfCookiesContent" | translate }}</p>
                    <h1>{{ "CookiePolicy.TypesOfCookiesTitle" | translate }}</h1>
                    <p>{{ "CookiePolicy.AnalyticalCookiesTitle" | translate }}</p>
                    <p>{{ "CookiePolicy.AnalyticalCookiesContent" | translate }}</p>
                    <h1>{{ "CookiePolicy.OnSiteCookiesTitle" | translate }}</h1>
                    <p>{{ "CookiePolicy.OnSiteCookiesContent" | translate }}</p>
                    <h1>{{ "CookiePolicy.ControllingCookiesTitle" | translate }}</h1>
                    <p>{{ "CookiePolicy.ControllingCookiesContent" | translate }}</p>
                </div>
            </div>
        </div>
       
    </div>
    
</div>